import React, { useState, useEffect } from "react";
import CommonForm from "../../../Common/Components/Form";
import { SubmitForm } from "./Components/Services";
import { ConvertDate } from "../../../Common/Function";
import FragmentInput from "./Components/FragmentInput";
import DropFile from "../../../Common/Components/DropFile";
import DatePicker, {
  Calendar,
  getAllDatesInRange,
} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
function Create() {
  const [state, setstate] = useState({
    data: null,
    loading: false,
    create: false,
  });
  const [fragment, setfragment] = useState({});

  const [form, setform] = useState({
    type_discount: "money",
    product_type: "all",
    item_category_id: null,
    fragment: "false",
    count: false,
  });

  const [count, setcount] = useState({});
  // useEffect(() => {
  //   if (window.$(".datePickerShamsi").length) {
  //     var inputs = window.$(".datePickerShamsi");
  //     window.$.each(inputs, function (i, item) {
  //       window.$(item).datepicker({
  //         dateFormat: "yy/mm/dd",
  //         showOtherMonths: true,
  //         selectOtherMonths: false,
  //       });
  //     });
  //   }
  // }, []);
  const Submit = () => {
    setstate({ ...state, loading: true });
    let obj = {
      ...form,
    };
    if (form.isCount) {
      obj = { ...obj, [form.count]: form.isCount };
    }
    SubmitForm({ ...obj }).then(() => {
      setstate({ ...state, loading: false });
    });
  };
  const bindData = data => {
    setform({ ...form, fragmentation: { ...data, count } });
  };
  const createInput = () => {
    let fragmentArray = [];
    setstate({ ...state, create: true });
    for (var i = 1; i <= count; i++) {
      fragmentArray.push({ key: `step${i}` });
    }
    setfragment(fragmentArray);
  };
  return (
    <div className="card">
      <div className="card-body">
        <div className="row">
          <div className="col mb-5">
            <h2>ایجاد کدتخفیف</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <lable>کد تخفیف</lable>
            <input
              onChange={e => {
                setform({ ...form, code: e.target.value });
              }}
              className="form-control mt-2 col-12"
            />
          </div>

          <div className="col-md-3">
            <label>نوع تخفیف:</label>
            <select
              onChange={e => {
                setform({ ...form, type_discount: e.target.value });
              }}
              className="form-control "
            >
              <option value={"money"}>پولی</option>
              <option value={"percentage"}>درصدی</option>
            </select>
          </div>
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="col-5 mt-4"
          >
            <input
              type="number"
              onChange={e => {
                setform({ ...form, amount_discount: parseInt(e.target.value) });
              }}
              placeholder={
                form.type_discount == "percentage"
                  ? "مقدار در صد"
                  : "مبلغ تخفیف"
              }
              className="form-control mt-2"
            />
            <lable className="mr-2">
              {form.type_discount == "percentage" ? "درصد" : "تومان"}
            </lable>
          </div>
          <div className="col-md-4 mt-2">
            <lable> تاریخ شروع</lable>
            <Calendar
              onChange={data => {
                setform({
                  ...form,
                  pro_time: ConvertDate(
                    `${data.year}/${data.month.number}/${data.day}`
                  ),
                });
              }}
              calendar={persian}
              locale={persian_fa}
            />
          </div>
          <div className="col-md-4 mt-2">
            <lable> تاریخ پایان</lable>
            <Calendar
              onChange={data => {
                setform({
                  ...form,
                  exp_time: ConvertDate(
                    `${data.year}/${data.month.number}/${data.day}`
                  ),
                });
              }}
              calendar={persian}
              locale={persian_fa}
            />
          </div>
          <div className="col-4 mt-2 ">
            <div className="col-12 mt-2">
              <label> اعمال تخفیف برای:</label>
              <select
                onChange={e => {
                  setform({ ...form, product_type: e.target.value });
                }}
                className="form-control"
              >
                <option value={"all"}>همه</option>
                <option value={"joinclass"}>ثبت نام در کلاس</option>
                <option value={"reserve"}>رزرواسیون</option>
                <option value={"contractual_reservation"}> رزرو قرادادی</option>
              </select>
            </div>
            {
              form.product_type == 'reserve' || form.product_type == 'contractual_reservation' ? (
                <div className="col-12 mt-2">
                  <label> دسته بندی مجموعه ها:</label>
                  <select
                    onChange={e => {
                      if (e.target.value != "all") {
                        setform({ ...form, item_category_id: e.target.value });
                      } else {
                        setform({ ...form, item_category_id: null });
                      }
                    }}
                    className="form-control"
                  >
                    <option value={"all"}>همه</option>
                    <option value={"1"}>استخر</option>
                    <option value={"2"}>سالن</option>
                    <option value={"3"}>باشگاه</option>
                  </select>
                </div>
              ) : <></>
            }
          </div>
          <div className="col-3 mt-2">
            <lable> حداقل قیمت سبد خرید</lable>
            <input
              type="number"
              onChange={e => {
                setform({ ...form, min_basket_price: e.target.value });
              }}
              className="form-control mt-2 col-12"
            />
          </div>
          <div className="col-3 mt-2">
            <label>حداکثر مقدار تخفیف</label>
            <input
              type="number"
              onChange={e => {
                setform({ ...form, max_offer_amount: e.target.value });
              }}
              disabled={form.type_discount == "money"}
              className="form-control  col-12"
            />
          </div>

          <br />
          <div className="col-12 mt-4">
            <lable> توضیحات کد تخفیف</lable>
            <textarea
              onChange={e => {
                setform({ ...form, description: e.target.value });
              }}
              className="form-control mt-2 col-12"
            />
          </div>
          <div className="col-3 mt-4">
            <label> تعداد استفاده: </label>

            <select
              onChange={e => {
                if (count) {
                  setform({ ...form, count: e.target.value });
                } else {
                  let newState = { ...form };
                  newState = delete newState["countallowd"];
                  newState = delete newState["countallowdwuser"];
                  setform({ ...newState });
                }
              }}
              className="form-control"
            // hidden={form.type_discount == "perecentage"}
            >
              <option value={""}>بدون تعداد</option>
              <option value={"forclup"}>بسته به باشگاه مشتریان</option>
              <option value={"countallowed"}>تعداد تک کاربره</option>
              <option value={"countallowedwuser"}>تعداد چند کاربره</option>
            </select>
          </div>
          {form.count && (
            <div className="col-3 mt-4">
              <label>
                {form.count != "forclup" ? "تعداد تخفیف" : "امتیاز لازم"}
              </label>
              <input
                type="number"
                onChange={e => {
                  setform({ ...form, isCount: e.target.value });
                }}
                className="form-control  col-12"
              />
            </div>
          )}
          {form.count && form.count === "forclup" && (
            <>
              <div className="col-3 mt-4">
                <label>لوگو تخفیف دهنده</label>
                <DropFile
                  set={e => {
                    setform({ ...form, offerlogo: e });
                  }}
                  accept={"image/png, image/jpeg"}
                  classNames={"mt-2"}
                />
              </div>
              <div className="col-3 mt-4">
                <label>تصویر تخفیف در باشگاه مشتریان</label>
                <DropFile
                  set={e => {
                    setform({ ...form, offerimage: e });
                  }}
                  accept={"image/png, image/jpeg"}
                  classNames={"mt-2"}
                />
              </div>
              <div className="col-12 mt-4">
                <label>متن برای صفحه اول کلاب</label>
                <input
                  type="text"
                  onChange={e => {
                    setform({ ...form, cluptext: e.target.value });
                  }}
                  className="form-control  col-12"
                />
              </div>
            </>
          )}
          <div className="col-4 mt-4 ">
            <label> مدل قیمت:</label>

            <select
              onChange={e => {
                setform({ ...form, fragment: e.target.value });
              }}
              className="form-control"
              hidden={form.type_discount == "perecentage"}
            >
              <option value={"false"}>قیمت اصلی</option>

              <option
                disabled={form.type_discount == "percentage" || form.count}
                value={"true"}
              >
                {" "}
                شکستن قیمت
              </option>
            </select>
          </div>

          <div
            hidden={form.fragment == "true" ? false : true}
            className="col-12 mt-2"
          >
            <label>تعداد</label>

            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="number"
                className="form-control  col-4"
                onChange={e => {
                  setcount(e.target.value);
                }}
              />

              <button
                className="btn btn-warning mr-3 mt-1"
                onClick={createInput}
              >
                ایجاد
              </button>
            </div>
          </div>
          <div className="col-12 ">
            {form.fragment == "true" && state.create && (
              <FragmentInput steps={fragment} handler={bindData} />
            )}
          </div>
          <div className="col-12 mt-4">
            <button className="btn btn-danger" onClick={() => Submit()}>
              ایجاد کدتخفیف
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Create;
